
import Vue from 'vue'

export default Vue.extend({
  props: {
    timeout: {
      type: Number,
      default: 1000
    }
  },
  data: () => ({
    interval: null as NodeJS.Timeout|null
  }),
  watch: {
    timeout () {
      this.stop()
      this.start()
    }
  },
  mounted () {
    this.update()
    this.start()
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    start () {
      this.interval = setInterval(() => {
        this.update()
      }, this.timeout)
    },
    stop () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    update () {
      this.$emit('onInterval')
    }
  },
  render: () => null as any
})
